import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbNavigation = ({ customItems = null }) => {
  const location = useLocation();

  const routeNameMap = {
    '/home-page': 'Home',
    '/search-results': 'Search Results',
    '/trailer-detail': 'Trailer Details',
    '/booking': 'Booking',
    '/dashboard': 'Dashboard',
    '/profile': 'Profile'
  };

  const generateBreadcrumbs = () => {
    if (customItems) {
      return customItems;
    }

    const pathSegments = location?.pathname?.split('/')?.filter(segment => segment);
    
    if (pathSegments?.length === 0 || location?.pathname === '/home-page') {
      return [];
    }

    const breadcrumbs = [
      { label: 'Home', path: '/home-page' }
    ];

    let currentPath = '';
    pathSegments?.forEach((segment) => {
      currentPath += `/${segment}`;
      const label = routeNameMap?.[currentPath] || segment?.charAt(0)?.toUpperCase() + segment?.slice(1)?.replace(/-/g, ' ');
      breadcrumbs?.push({
        label,
        path: currentPath
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs?.length === 0) {
    return null;
  }

  return (
    <nav aria-label="Breadcrumb" className="py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ol className="flex items-center space-x-2 flex-wrap">
          {breadcrumbs?.map((crumb, index) => {
            const isLast = index === breadcrumbs?.length - 1;
            const isFirst = index === 0;

            return (
              <li key={crumb?.path} className="flex items-center">
                {!isFirst && (
                  <Icon 
                    name="ChevronRight" 
                    size={16} 
                    strokeWidth={2} 
                    className="text-muted-foreground mx-2"
                  />
                )}
                {isLast ? (
                  <span className="font-body text-foreground font-medium" aria-current="page">
                    {crumb?.label}
                  </span>
                ) : (
                  <Link
                    to={crumb?.path}
                    className="font-body text-muted-foreground hover:text-primary transition-smooth"
                  >
                    {crumb?.label}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>

        <button
          onClick={() => window.history?.back()}
          className="mt-3 md:hidden flex items-center space-x-2 text-primary hover:text-primary/80 transition-smooth"
        >
          <Icon name="ArrowLeft" size={18} strokeWidth={2} />
          <span className="font-body font-medium">Back</span>
        </button>
      </div>
    </nav>
  );
};

export default BreadcrumbNavigation;